import { Colors } from '../../theme';

export default {
  imageDefault: {
    width: '48px',
  },
  icon: {
    width: 16,
    height: 16
  } as React.CSSProperties,
  iconS: {
    width: 24,
    height: 24
  } as React.CSSProperties,
  iconM: {
    width: 32,
    height: 32,
  } as React.CSSProperties,
  iconL: {
    width: 64,
    height: 64
  } as React.CSSProperties,
  iconXL: {
    width: 128,
    height: 128,
    objectFit: 'contain'
  } as React.CSSProperties,
  icon120: {
    width: 120,
    height: 120,
  } as React.CSSProperties,
  icon200: {
    width: 200,
    height: 200,
  } as React.CSSProperties,
  icon250: {
    width: 250,
    height: 250,
  } as React.CSSProperties,
  iconTable: {
    color: Colors.lightPurple,
    fontSize: '18px',
    cursor: 'pointer'
  } as React.CSSProperties,
};
